module.exports = __webpack_public_path__ + "img/69.5e341e0b.jpg";